module.exports = __webpack_public_path__ + "img/花鼓.SLDPRT.bb75575a.jpg";